export function renameItemInSidebar(type, key, newKey) {
  type = this.getPlural(type)

  const item = this.call('findFileSidebarItem', type, key)
  if (!item) {
    return
  }

  item.state.update({
    key: newKey
  })
}

export async function rename(type, oldKey, newKey) {
  if (!type || !oldKey || !newKey) {
    return this.error('Type, old name or new name is not defined for rename operation')
  }

  type = this.getPlural(type)

  const confirmMsg = `Do you want to rename "${oldKey}" to "${newKey}" in ${type}?`
  if (!window.confirm(confirmMsg)) {
    return false
  }

  let item = this.call('getItem', oldKey, type)

  if (!item) {
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'editor.crud.notFound.title'),
      message: this.call('polyglot', 'editor.crud.notFound.message')
        .replace('{key}', oldKey)
        .replace('{type}', type)
    })
    return this.error('Could not find target element')
  }

  if (this.call('getItem', newKey, type)) {
    this.call('openNotification', {
      type: 'error',
      title: this.call('polyglot', 'editor.crud.renameFailed.title'),
      message: this.call('polyglot', 'editor.crud.renameFailed.message').replace('{newKey}', newKey)
    })
    return this.error('Could not rename')
  }

  item = this.call('deepClone', item)
  item.key = newKey

  this.call('removeAny', type, oldKey, {
    skipConfirmation: true,
    skipSidebar: true
  }) // add skipSidebar, skipConfirmation
  this.call('createItem', type, newKey, item, {
    skipSidebar: true
  })

  this.call('renameItemInSidebar', type, oldKey, newKey)
}
